// extracted by mini-css-extract-plugin
module.exports = {"list":"_3RzsdU6Ewm_calculator"};